// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RanaDirectory
 */
export interface RanaDirectory {
  /**
   *
   */
  id: string;
  /**
   *
   */
  ref?: string;
  /**
   *
   */
  variableType?: RanaDirectoryVariableTypeEnum;
}

/**
 * @export
 */
export const RanaDirectoryVariableTypeEnum = {
  RanaPath: "rana_path",
} as const;
export type RanaDirectoryVariableTypeEnum =
  (typeof RanaDirectoryVariableTypeEnum)[keyof typeof RanaDirectoryVariableTypeEnum];

/**
 * Check if a given object implements the RanaDirectory interface.
 */
export function instanceOfRanaDirectory(value: object): value is RanaDirectory {
  if (!("id" in value) || value["id"] === undefined) return false;
  return true;
}

export function RanaDirectoryFromJSON(json: any): RanaDirectory {
  return RanaDirectoryFromJSONTyped(json, false);
}

export function RanaDirectoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RanaDirectory {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    ref: json["ref"] == null ? undefined : json["ref"],
    variableType: json["variable_type"] == null ? undefined : json["variable_type"],
  };
}

export function RanaDirectoryToJSON(json: any): RanaDirectory {
  return RanaDirectoryToJSONTyped(json, false);
}

export function RanaDirectoryToJSONTyped(
  value?: RanaDirectory | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    ref: value["ref"],
    variable_type: value["variableType"],
  };
}
